<template>
    <div class="mask">
        <div class="popup" :class="showHeader ? 'header-pop' : ''" v-loading.body="showPopupLoading" :style="'opacity: ' + popupOpacity">
            <div class="header" v-if="showHeader" :class="title ? '' : 'no-border-bottom'">
                <p class="title" v-if="title">{{ title }}</p>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <i v-if="!showHeader" class="el-icon-circle-cross close popup-close" @click="close"></i>
            <div class="content" :class="isWidth ? 'width-content' : 'narrow-content'">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title', 'isWidth', 'showHeader', 'showPopupLoading', 'opacity'],
        computed: {
          popupOpacity() {
              if(this.opacity) {
                  return this.opacity;
              } else {
                  return 1;
              }
          }
        },
        methods: {
            close() {
                document.body.style.overflowY = 'auto';
                this.$emit('close');
            }
        },
        created() {
            document.body.style.overflowY = 'hidden';
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .no-border-bottom {
        border: none !important;
        height: 50px !important;
    }

    .mask {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        position: fixed;
        overflow: auto;
        margin: 0;
        z-index: 100;
        background: rgba(0, 0, 0, 0.5);
        @include flex-row-center;
        .header-pop {
            border-top: 10px solid $blue-color;
        }
        .popup {
            min-width: 550px;
            max-width: 900px;
            height: auto;
            background: #e4e4e4;
            background-size: 100% 100%;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.6);
            position: relative;
            .header {
                width: 100%;
                height: 70px;
                overflow: hidden;
                @include flex-row-center;
                border-bottom: 2px solid #ededed;
                position: relative;
                .title {
                    font-size: 25px;
                    color: #000;
                }
            }
            .close {
                position: absolute;
                right: 0;
                top: 0;
                font-size: 20px;
                font-weight: bolder;
                color: $blue-color;
                cursor: pointer;
                width: 30px;
                height: 30px;
                border: 3px solid $blue-color;
                border-top: 0;
                @include flex-row-center;
            }
            .popup-close {
                position: absolute;
                top: -12px;
                right: -17px;
                background: #fff;
                border-radius: 50%;
            }
            .content {
                box-sizing: border-box;
            }
            .narrow-content {
                width: 100%;
                padding: 20px;
            }
            .width-content {
                width: 800px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Popup.vue?3ff1bac4